var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9989 16C31.9989 9.37234 26.6263 4 19.9997 4C13.371 4 7.99902 9.37218 7.99902 16C7.99902 22.6268 13.3712 28 19.9997 28C26.6265 28 31.9989 22.6268 31.9989 16Z",
    fill: "#3D83D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.063 13.0703H14.2852V21.0091H17.063V13.0703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6742 9.10156C14.804 9.10156 14.1229 9.90117 14.3191 10.8019C14.4331 11.3251 14.8598 11.7457 15.3849 11.8511C16.2803 12.031 17.063 11.3532 17.063 10.4906C17.063 9.7247 16.4424 9.10156 15.6742 9.10156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1928 15.5091C26.006 14.0128 25.2575 13.0703 23.2348 13.0703C21.7992 13.0703 21.2284 13.2942 20.8992 13.9209V13.0703H18.6504V21.0091H20.9647V16.8535C20.9647 15.8161 21.1612 15.0325 22.4439 15.0325C23.7082 15.0325 23.8098 15.9969 23.8098 16.9208V21.0093H26.193C26.1928 21.0093 26.2369 15.8588 26.1928 15.5091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -0.000976562,
    y: 0,
    width: 39.9998,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.160784 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.5813aa7fc5b912b4f58304d0f06681e7.svg";
export { ForwardRef as ReactComponent };